function ps() {
	console.log('hello world');
	
	if (navigator.maxTouchPoints > 0) {
		$('body').addClass('y');
	}
	
	$('.nx').click(function(e) {
		e.preventDefault();
	});

	$('.credit > span').click(function() {
		$(this).closest('.credit').toggleClass('on');
	});


	function nv__1() {
		if ($(window).width() > 920) {
			$('body').removeClass('nv--on');

			$('.ss-menu').removeClass('secondary--sub-on');
			$('.i-sub > .in > div').removeClass('on');
			$('.i-sub > .in > div > span').attr('data-state', '1');

			$('header').removeClass('sub-on');
			$('.nv ul.m > li.s').removeClass('on');
			$('.nv ul.m > li.s > a').attr('data-state', '1');
		} else {
			$('#m-btn').attr('data-state', '1').removeClass('on');
		}
	  }
	
	  nv__1();
	
	$(window).on('resize', function() {
		nv__1();
	});

    const ft__ = function() {
		$('.ft--nv .ln__ a.sltd').attr('data-state', '1')

		$('.ft--nv .ln__ a.sltd').click(function(e) {
            if ($(this).attr('data-state') == 1) {
                $('.ft--nv ul > li.ln__').addClass('on');
                $(this).attr('data-state', '0');
            } else {
                $('.ft--nv ul > li.ln__').removeClass('on');
                $(this).attr('data-state', '1');
            }
            e.preventDefault();
        });
	}
	ft__();

	if ($('.pd').length) {
		var lb__1;

		function initLbSwiper() {
			if (window.innerWidth > 920) {

				if (!$('.pd').length) return;

				if (!lb__1) {
					lb__1 = new Swiper('.lb-imgs .swiper', {
						direction:'horizontal',
						loop:false,
						slidesPerView:'auto',
						spaceBetween:0,
						speed:450,
						mousewheel:{
							forceToAxis:true,
						},
						scrollbar:{
							el:'.lb-imgs .swiper-scrollbar',
							draggable:true
						},
					});
				}

			} else {

				if (lb__1) {
					lb__1.destroy(true, true);
					lb__1 = null;
				}

			}
		}

		initLbSwiper();

		$(window).on('resize', function () {
			initLbSwiper();
		});
	}

	/* ============================================================
	   size guide
	   [수정 1] $('.sg--btn').click() 직접 바인딩 → $(document).on() 위임
	   .sg--btn 은 <variant-selects> 내부에 있어 Dawn 의 product-info.js 가
	   섹션을 재렌더하면 노드가 교체되고 직접 바인딩된 핸들러는 사라진다.
	   document 는 교체되지 않으므로 위임하면 재렌더와 무관하게 동작한다.
	   ============================================================ */
	const sg__ = function() {
		$(document).on('click', '.sg--btn', function(e) {
			e.preventDefault();
			$('.s-g').addClass('on');
			$('body').addClass('fixed');
		});

		$(document).on('click', '.s-g .clos, .s-g > .over', function(e) {
			e.preventDefault();
			$('.s-g').removeClass('on');
		});
	}
	sg__();


	/* toji */
	const tj__ = function() {
		if ($('body').hasClass('tj__')) {
			$('.ss-tab > ul > li').removeClass('sltd');
			$('.ss-tab > ul > li.goto-tj').addClass('sltd');

			$('.logo').attr('href', '/pages/toji');
		}

		if ($('.f__nv').length) {
			$('.f__nv > li').click(function(e) {
				var target = $(this).data('id');

				$('.f__nv > li').removeClass('sltd');
				$('.f__item').removeClass('on');

				$(this).addClass('sltd');

				$('.f__item').each(function() {
					var id = $(this).attr('id');

					if (target === id) {
						$(this).addClass('on');
					}
				});

				e.preventDefault();
			});

			function initFeatureSwiper() {
				$('.f__img.swiper').each(function(){
					var $this = $(this);
			
					if(window.innerWidth <= 600){
						if(!$this.hasClass('swiper-initialized')){
							new Swiper(this, {
								direction: 'horizontal',
								loop: false,
								slidesPerView: 'auto',
								spaceBetween: 0,
								mousewheel: {
									forceToAxis: true,
								},
								scrollbar:{
									el:$this.find('.swiper-scrollbar')[0],
									draggable:true
								}
							});
						}
					} else {
						if (this.swiper) {
							this.swiper.destroy(true, true);
						}
					}
				});
			}
			
			initFeatureSwiper();
			
			$(window).resize(function(){
				initFeatureSwiper();
			});
		}


		const idx_ = function() {
			var $nav = $('.idx__nv');
			var $links = $nav.find('a[data-target]');
			var offsetTop = 200;
		
			function setActiveByScroll(){
				var scrollTop = $(window).scrollTop();
				var winH = $(window).height();
				var triggerLine = scrollTop + winH - 600;
		
				var currentId = null;
		
				$links.each(function(){
					var targetId = $(this).data('target');
					var $target = $('#' + targetId);
		
					if(!$target.length) return;
		
					if($target.offset().top <= triggerLine){
						currentId = targetId;
					}
				});
		
				if(currentId){
					$nav.find('li').removeClass('sltd');
					$links.filter('[data-target="' + currentId + '"]').closest('li').addClass('sltd');
				}
			}
		
			$links.click(function(e){
				e.preventDefault();
		
				var targetId = $(this).data('target');
				var $target = $('#' + targetId);
		
				if(!$target.length) return;
		
				$('html, body').animate({
					scrollTop: $target.offset().top - offsetTop
				}, 400);
		
				$nav.find('li').removeClass('sltd');
				$(this).closest('li').addClass('sltd');
			});
		
			setActiveByScroll();
		
			$(window).on('scroll resize', function(){
				setActiveByScroll();
			});
		}
		idx_();


		/* ============================================================
		   [수정 2] sizing swiper 존재 여부 가드 추가
		   toji_sizing 메타필드가 없는 상품에서는 .sz__1 / .sz__2 가
		   렌더되지 않아 sz__1.on('slideChange') 에서 TypeError 가 발생하고,
		   그 뒤의 st__ / ar__ / log__ / nv__ / p__s 가 전부 실행되지 않는다.
		   ============================================================ */
		if ($('.sz__1').length && $('.sz__2').length) {
			var sz__2 = new Swiper('.sz__2', {
				slidesPerView: 'auto',
				spaceBetween: 8,
				watchSlidesProgress: true
			});

			var sz__1 = new Swiper('.sz__1', {
				direction: 'horizontal',
				loop: false,
				slidesPerView: 'auto',
				spaceBetween: 0,
				speed: 0,
				mousewheel: {
					forceToAxis: true,
				},
				scrollbar:{
					el:'.sz__1 .swiper-scrollbar',
					draggable:true
				},
				thumbs:{
					swiper: sz__2
				}
			});


			$('.sz__2 .swiper-slide').on('mouseenter click', function(){
				var idx = $(this).index();

				sz__1.slideTo(idx);
			});


			sz__1.on('slideChange', function(){
				var idx = sz__1.activeIndex;

			});
		}
	}
	tj__();

	/* stores */
	const st__ = function() {
		if ($('.st__').length) {
			var i1_ = $('.st__ .cont > ul > li.sltd').find('.img img').attr('src');
				$('.i__ img').attr('src', i1_);

			$('.st__ .cont > ul > li > div > h4').click(function() {
				$('.st__ .cont > ul > li').removeClass('sltd');

				var i__ = $(this).closest('li').find('.img img').attr('src');
				$('.i__ img').attr('src', i__);

				$(this).closest('li').addClass('sltd');
			});
		}

		/* stockist */
		if ($('.rg_').length) {
			$('.rg_ ul > li a').attr('target', '_blank');
			$('.rg_ ul > li a[href="#"]').addClass('nx');
			$('.rg_ ul > li a[href="#"]').click(function(e) {
				e.preventDefault();
			});
		}
	}
	st__();



	/* archive */
	const ar__ = function() {
		$(function() {
			const $nav = $('.sub--nv ul');
			const $active = $nav.find('li.sltd');
		
			if ($active.length) {
				$nav.scrollLeft(
					$active.position().left + $nav.scrollLeft() - 16
				);
			}

			$('.sub--nv').each(function(){
				var $nav = $(this);
		
				if ($nav.children('ul').children('li').length === 0) {
					$nav.addClass('hidn');
				}
			});
		});

		if ($('.a__').length) {
			const archiveSwipers = [];
		
			$('.a__ .imgs.swiper').each(function () {
				var $el = $(this);
				var $scrollbar = $el.find('.swiper-scrollbar');
		
				var swiper = new Swiper($el[0], {
					direction: 'horizontal',
					loop: false,
					slidesPerView: 'auto',
					spaceBetween: 0,
					freeMode: {
						enabled: true,
						sticky: false,
					},
					mousewheel: {
						forceToAxis: true,
					},
					scrollbar: {
						el: $scrollbar[0],
						draggable: true,
					},
				});
		
				archiveSwipers.push(swiper);
			});
		
			$('.sub--nv a').click(function(e) {
				e.preventDefault();
			
				var season = $(this).data('season');
			
				sessionStorage.setItem('archiveSeason', season);
				history.replaceState(null, '', '?sn=' + season);
			
				$('.archive .sub--nv li').removeClass('sltd');
				$(this).parent().addClass('sltd');
			
				$('html, body').animate({ scrollTop: 0 }, 0);
			
				$('.archive .cont .item').hide();
			
				if (season === 'all') {
					$('.archive .cont .item').show();
				} else {
					$('.archive .cont .item[data-season="' + season + '"]').show();
				}
			
				setTimeout(function() {
					archiveSwipers.forEach(function(swiper) {
						swiper.slideTo(0, 0);
						swiper.update();
			
						if (swiper.scrollbar && swiper.scrollbar.updateSize) {
							swiper.scrollbar.updateSize();
						}
			
						if (swiper.scrollbar && swiper.scrollbar.setTranslate) {
							swiper.scrollbar.setTranslate();
						}
					});
				}, 50);
			});
			
			var urlSeason = new URLSearchParams(window.location.search).get('sn');
			var savedSeason = sessionStorage.getItem('archiveSeason');
			var activeSeason = urlSeason || savedSeason;

			if (activeSeason) {
				var $activeTab = $('.sub--nv a[data-season="' + activeSeason + '"]');

				if ($activeTab.length) {
					$activeTab.trigger('click');
				}
			}
		}

		if ($('.av_').length) {
			let s__1 = null;
			let s__2 = null;
			let isActive = false;
		
			function initSwiper() {
				if (isActive) return;
		
				s__2 = new Swiper('.a-v .s__2 .swiper', {
					direction:'horizontal',
					slidesPerView:'auto',
					spaceBetween:0,
					watchSlidesProgress:true,
					speed:0,
				});
		
				s__1 = new Swiper('.a-v .s__1 .swiper', {
					direction:'horizontal',
					loop:false,
					slidesPerView:'auto',
					spaceBetween:0,
					speed:250,
					freeMode:{
						enabled:true,
						sticky:false,
					},
					mousewheel:{
						forceToAxis:false,
					},
					thumbs:{
						swiper:s__2,
					},
				});
		
				isActive = true;
			}
		
			function destroySwiper() {
				if (!isActive) return;
		
				if (s__1) {
					s__1.destroy(true, true);
					s__1 = null;
				}
		
				if (s__2) {
					s__2.destroy(true, true);
					s__2 = null;
				}
		
				isActive = false;
			}
		
			function handleSwiper() {
				if (window.innerWidth <= 920) {
					destroySwiper();
				} else {
					initSwiper();
				}
			}
		
			handleSwiper();
		
			$(window).resize(function () {
				handleSwiper();
			});
		}
	}
	ar__();


	/* addresses */
	const adr__ = function() {
		$('ul.list > li button.edit').click(function() {
			$(this).closest('li').addClass('on');
			$('.customer').addClass('adr--edit');
		});

		$('.addresses .btn2[aria-controls="AddAddress"]').click(function() {
			$('.customer').addClass('adr--open');
		});

		$('.add__ .back--btn').click(function() {
			$('.customer').removeClass('adr--open');
		});

		$('.edit__ .back--btn').click(function() {
			$('ul.list > li').removeClass('on');
			$('.customer').removeClass('adr--edit');
		});
	}
	adr__();

	
	const log__ = function() {
        $('.log--btn').click(function(e) {
			$('body').addClass('log--on');

			e.preventDefault();
		});

		$('.login-modal .cls_.clos--log, header > y').click(function(e) {
			$('body').removeClass('log--on');
            
            $('.login-modal #recover').hide();
			$('.login-modal #login').show();
			e.preventDefault();
		});

        $('.login-modal #login .t1__').click(function(e) {
            if ($('body').hasClass('nv--on') || $('body').hasClass('log--on')) {
                $('body').removeClass('log--on');
            }
			e.preventDefault();
		});

		/* forgot your password */
		$('.login-modal .fp_').click(function(e) {
			$('.login-modal #login').hide();
            $('.login-modal #recover').show();
			e.preventDefault();
		});

		$('.login-modal #recover .t1__').click(function(e) {
            if ($('body').hasClass('nv--on') || $('body').hasClass('log--on')) {
                $('.login-modal #recover').hide();
            	$('.login-modal #login').show();
            }
			e.preventDefault();
		});

		$('.clos--rs').click(function(e) {
			$('.login-modal #recover').hide();
            $('.login-modal #login').show();
			e.preventDefault();
		});
	}
	log__();

	const p__ = function() {
		$('.sub--nv li').each(function () {
			var href = $(this).find('a').attr('href');
		  
			if (window.location.pathname === href) {
			  $(this).addClass('sltd');
			}
		});

		$('.sort__list a').each(function(){
			var sort = $(this).data('sort');
			var url = new URL(window.location.href);
		  
			url.searchParams.set('sort_by', sort);
		  
			$(this).attr('href', url.toString());
		});
	}
	p__();


	const rp__ = function() {
		function initRpSwiper() {
			$('.r-p').each(function() {
				var $wrap = $(this);
				var $swiper = $wrap.find('.swiper');
				var $scrollbar = $wrap.find('.swiper-scrollbar');
	
				if (!$swiper.length) return;
				if ($swiper.hasClass('swiper-initialized')) return;
	
				new Swiper($swiper[0], {
					direction:'horizontal',
					loop:false,
					slidesPerView:'auto',
					spaceBetween:0,
					speed:0,
					freeMode:{
						enabled:true,
						sticky:false
					},
					mousewheel:{
						forceToAxis:true
					},
					scrollbar:{
						el:$scrollbar[0]
					},
					observer:true,
					observeParents:true
				});
			});
		}
	
		initRpSwiper();
	
		setTimeout(initRpSwiper, 300);
		setTimeout(initRpSwiper, 800);
		setTimeout(initRpSwiper, 1500);
	
		new MutationObserver(function() {
			initRpSwiper();
		}).observe(document.body, {
			childList:true,
			subtree:true
		});
	}
	rp__();
	/* collection list */
	function flipGrid(changeFn) {
		const items = document.querySelectorAll('.cl__ ul.p > li');
	
		const first = [];
		items.forEach(el => {
			first.push(el.getBoundingClientRect());
		});
	
		changeFn(); // 여기서 tp--1,2,3 변경
	
		const last = [];
		items.forEach(el => {
			last.push(el.getBoundingClientRect());
		});
	
		items.forEach((el, i) => {
			const dx = first[i].left - last[i].left;
			const dy = first[i].top - last[i].top;
	
			el.style.transform = `translate(${dx}px, ${dy}px)`;
			el.style.transition = 'transform 0s';
	
			requestAnimationFrame(() => {
				el.style.transform = '';
				el.style.transition = 'transform 450ms cubic-bezier(.4,.55,.05,.96)';
			});
		});
	}
	
	const cl__ = function() {
		$(function() {
			const $nav = $('.cl-nv ul');
			const $active = $nav.find('li.active');
		
			if ($active.length) {
				$nav.scrollLeft(
					$active.position().left + $nav.scrollLeft() - 16
				);
			}

			$('.cl-nv').each(function(){
				var $nav = $(this);
		
				if ($nav.children('ul').children('li').length === 0) {
					$nav.addClass('hidn');
				}
			});
		});

		$('.cl-switch > div.p_ > span').click(function(e) {
			e.preventDefault();
		
			var $btn = $(this);
			var id = this.id;
		
			flipGrid(function() {
				$('.cl-switch > div > span').removeClass('on');
				$btn.addClass('on');
		
				$('.cl__ ul.p').removeClass('tp--1 tp--2 tp--3');
		
				if (id === 'tp__1') {
					$('.cl__ ul.p').addClass('tp--1');
				} else if (id === 'tp__2') {
					$('.cl__ ul.p').addClass('tp--2');
				} else if (id === 'tp__3') {
					$('.cl__ ul.p').addClass('tp--3');
				}
			});
		});

		var $i_ = $('ul.p');
		var $minus = $('#tp__minus');
		var $plus = $('#tp__plus');

		function getTp() {
			var match = $i_.attr('class')?.match(/tp--m(\d)/);
			return match ? parseInt(match[1]) : 2; // 초기값 = tp--m2
		}

		function setTp(n) {
			flipGrid(function() {
				$i_.removeClass('tp--m1 tp--m2 tp--m3')
					.addClass('tp--m' + n);
		
				u__btn(n);
			});
		}

		function u__btn(n) {
			$minus.removeClass('deactive');
			$plus.removeClass('deactive');

			if (n === 1) {
				$plus.addClass('deactive');
			}

			if (n === 3) {
				$minus.addClass('deactive');
			}
		}

		$('#tp__minus').on('click', function () {
			var current = getTp();
			if (current < 3) setTp(current + 1);
		});

		$('#tp__plus').on('click', function () {
			var current = getTp();
			if (current > 1) setTp(current - 1);
		});

		u__btn(getTp());



		const p_dsc = function() {
			$('.p__dsc > ul > li > span').attr('data-state', '1');
			$('.p__dsc > ul > li.on > span').attr('data-state', '0');

			function x() {
				$('.p__dsc > ul > li').removeClass('on');
				$('.p__dsc > ul > li > span').attr('data-state', '1');
				$('.p__dsc').removeClass('on');
			}
			$('.p__dsc > ul > li > span').click(function(e) {
				if ($(this).attr('data-state') == 1) {
					x();
					$('.p__dsc').addClass('on');
					$(this).parent('li').addClass('on');
					$(this).attr('data-state', '0');
				} else {
					x();
				}
				e.preventDefault();
			});

			$('.p__dsc > ul > li i.plus').click(function(e) {
				x();
				e.preventDefault();
			});
		}
		p_dsc();
	}
	cl__();

	const nv__ = function() {
		$('#m-btn').attr('data-state', '1');

		$('.nv ul.m > li.s > a, .i-sub > .in > div > span').attr('data-state', '1');


		var sf_ = false;
		
		$('#m-btn').click(function(e) {
			sf_ = true;

			$('header').removeClass('ss-on tj-on');

			$('.ss-tab li').removeClass('sltd');

			if ($('body').hasClass('tj__')) {
				$('header').addClass('tj-on');

				$('.ss-tab li.goto-tj').addClass('sltd');
			} else {
				$('.ss-tab li.goto-ss').addClass('sltd');
			}

			$('.ss-menu').removeClass('secondary--sub-on');
			$('.i-sub > .in > div').removeClass('on');
			$('.i-sub > .in > div > span').attr('data-state', '1');

			$('header').removeClass('sub-on');
			$('.nv ul.m > li.s').removeClass('on');
			$('.nv ul.m > li.s > a').attr('data-state', '1');

			setTimeout(function () {
				$('.header__search .search__input').blur();
				sf_ = false;
			}, 100);
			if ($(this).attr('data-state') == 1) {
				$('#m-btn').attr('data-state', '0').addClass('on');
				$('body').addClass('nv--on');
			} else if ($(this).attr('data-state') == 0) {
				$('#m-btn').attr('data-state', '1')
				.removeClass('on');
				$('body').removeClass('nv--on');
			}
			e.preventDefault();
		});

		$(document).on('focus', '.nv .s__ .search__input.field__input', function () {
			if (sf_) {
				this.blur();
			}
		});
		/*
		$(document).on('input', '.nv .s__ .search__input.field__input', function () {
			if ($(this).val().trim() === '') {
				this.blur();
			}
		});*/

		$('.nv > .over').click(function(e) {
			$('#m-btn').attr('data-state', '1').removeClass('on');
			$('body').removeClass('nv--on');
		});

		$('.nv').mouseenter(function() {
			if (!($('body').hasClass('nv--on'))) {
				$('header').addClass('nv-on');
			}
		}).mouseleave(function() {
			if (!($('body').hasClass('nv--on'))) {
				$('header').removeClass('nv-on ss-on tj-on');

                $('.ss-tab li').removeClass('sltd');
                
                if ($('body').hasClass('tj__')) {
                    $('.ss-tab li.goto-tj').addClass('sltd');
                } else {
                    $('.ss-tab li.goto-ss').addClass('sltd');
                }
			}
		});

        /* ss-tab */
        $('.ss-tab li > a').mouseenter(function() {
            if (!($('body').hasClass('nv--on'))) {
                var li = $(this).parent('li');
                var id = li.data('id');
        
                li.addClass('sltd').siblings('li').removeClass('sltd');
                $('header').removeClass('ss-on tj-on').addClass(id + '-on');
            }
        });

		/* mobile */
		$('.ss-tab li > a').click(function(e) {
			if ($('body').hasClass('nv--on')) {
				$('header').removeClass('sub-on');
				$('.nv ul.m > li.s').removeClass('on');
				$('.nv ul.m > li.s > a').attr('data-state', '1');

				$('.ss-menu').removeClass('secondary--sub-on');
				$('.i-sub > .in > div').removeClass('on');
				$('.i-sub > .in > div > span').attr('data-state', '1');


				var li = $(this).parent('li');
				var id = li.data('id');
			
				li.addClass('sltd').siblings('li').removeClass('sltd');
				$('header').removeClass('ss-on tj-on').addClass(id + '-on');
			
				e.preventDefault();
			}
		});



		$('.nv ul.m > li.s').mouseenter(function() {
			if (!($('body').hasClass('nv--on'))) {
				$('header').addClass('sub-on');
			}
		}).mouseleave(function() {
			if (!($('body').hasClass('nv--on'))) {
				$('header').removeClass('sub-on');
			}
		});

		$('.nv .i-sub > .in > div').mouseenter(function() {
			$('.nv .i-sub').addClass('on');
		}).mouseleave(function() {
			$('.nv .i-sub').removeClass('on');
		});


		/* mobile */
		$('.nv ul.m > li.s > a').click(function(e) {
			if ($('body').hasClass('nv--on')) {
				if ($(this).attr('data-state') == 1) {
					$('header').addClass('sub-on');
					$('.nv ul.m > li.s').removeClass('on');
					$(this).parent().addClass('on');
	
					$('.nv ul.m > li.s > a').attr('data-state', '1');
					$(this).attr('data-state', '0');
				} else if ($(this).attr('data-state') == 0) {
					$('header').removeClass('sub-on');
					$('.nv ul.m > li.s').removeClass('on');
					$('.nv ul.m > li.s > a').attr('data-state', '1');
				}
			}
			e.preventDefault();
		});

		$('.i-sub > .in > div > span').click(function(e) {
			if ($(this).attr('data-state') == 1) {
				$('.ss-menu').addClass('secondary--sub-on');
				$('.i-sub > .in > div').removeClass('on');
				$('.i-sub > .in > div > span').attr('data-state', '1');
				
				$(this).parent('div').addClass('on');
				$(this).attr('data-state', '0');
			} else if ($(this).attr('data-state') == 0) {
				$('.ss-menu').removeClass('secondary--sub-on');
				$('.i-sub > .in > div').removeClass('on');
				$('.i-sub > .in > div > span').attr('data-state', '1');
			}
			e.preventDefault();
		});
	}

	nv__();

	/* img slide */
	const p__s = function() {
		var s_1 = document.querySelector('.s__1 .swiper-wrapper');
		var s__1 = document.querySelectorAll('.s__1 .swiper-slide');
		var s__2 = document.querySelectorAll('.s__2 .swiper-slide');
		var s__top = document.querySelector('.s__1');
		var pi__ = document.querySelector('.p__info');
		var rv__ = document.querySelector('.rv__');

		function checkPiOn() {
			if (!pi__) return;
		
			var rect = pi__.getBoundingClientRect();
		
			if (rect.top <= -400) {
				document.body.classList.add('is--info--on');
			} else {
				document.body.classList.remove('is--info--on');
			}
		}
		
		function checkRvHidePi() {
			if (!rv__) return;
		
			var rect = rv__.getBoundingClientRect();
		
			if (rect.top < window.innerHeight) {
				document.body.classList.remove('is--info--on');
			}
		}

		if (s_1 && s__1.length && s__2.length) {
			document.querySelector('.s__1 .swiper')?.classList.add('is-desktop-static');
			document.querySelector('.s__2 .swiper')?.classList.add('is-desktop-thumbs');

			s__1.forEach(function (slide, index) {
				slide.style.height = '';
				slide.style.transform = '';
				slide.setAttribute('data-index', index);
			});

			s_1.style.transform = '';
			s_1.style.transitionDuration = '';

			function setActiveThumb(index) {
				s__2.forEach(function (thumb, i) {
					thumb.classList.toggle('active', i === index);
				});

				if (s__2[index]) {
					s__2[index].scrollIntoView({
						block: 'nearest',
						inline: 'nearest',
						behavior: 'smooth'
					});
				}
			}

			function checkStickyEnd() {
				var s__top = document.querySelector('.g-s:not(.hidden) .s__1');
			
				if (!s__top) return;
			
				var rect = s__top.getBoundingClientRect();
			
				if (rect.bottom <= window.innerHeight) {
					document.body.classList.add('s__end');
				} else {
					document.body.classList.remove('s__end');
				}
			}

			s__2.forEach(function (thumb, index) {
				thumb.addEventListener('click', function () {
					if (s__1[index]) {
						s__1[index].scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}

					$('.product__media').removeClass('zoomed dragging');
				});
			});

			var visibleMap = new Map();

			var observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					var index = Number(entry.target.getAttribute('data-index'));
					visibleMap.set(index, entry.intersectionRatio);
				});

				var activeIndex = 0;
				var maxRatio = 0;

				visibleMap.forEach(function (ratio, index) {
					if (ratio > maxRatio) {
						maxRatio = ratio;
						activeIndex = index;
					}
				});

				setActiveThumb(activeIndex);
				checkStickyEnd();
			}, {
				root: null,
				threshold: buildThresholdList()
			});

			function buildThresholdList() {
				var thresholds = [];
				for (var i = 0; i <= 1; i += 0.05) {
					thresholds.push(i);
				}
				return thresholds;
			}

			s__1.forEach(function (slide) {
				observer.observe(slide);
			});

			function handleScrollState() {
				checkPiOn();
				checkRvHidePi();
				checkStickyEnd();
			}

			setActiveThumb(0);
			handleScrollState();

			window.addEventListener('scroll', handleScrollState);
			window.addEventListener('resize', handleScrollState);
		}

		/* mobile */
		var s__m = new Swiper ('.s__m .swiper', {
			// Optional parameters
			direction: 'horizontal',
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 0,
			speed: 450,
			mousewheel: {
				forceToAxis: true,
			},
			scrollbar: {
				el: '.s__m .swiper-scrollbar',
			},
		});


		function toggleGallery(){

            var selectedSize = $('fieldset').filter(function(){
                return $(this).find('legend.form__label').text().trim().toLowerCase() === 'size';
            }).find('input:checked').val();
        
            if($('.gs__0').length){
        
                if(selectedSize === '0'){
                    $('.gs__1').addClass('hidden');
                    $('.gs__0').removeClass('hidden');
                }else{
                    $('.gs__0').addClass('hidden');
                    $('.gs__1').removeClass('hidden');
                }
        
                window.scrollTo({
                    top:0
                });
            }
        }
        
        toggleGallery();
        
        $(document).on('change', 'variant-selects input[type="radio"]', function(){
            toggleGallery();
        });
	}
	p__s();
}

window.addEventListener('load',function(){
	var aniItems=document.querySelectorAll('.toji__ .ani__');

	if(!aniItems.length) return;

	var observer=new IntersectionObserver(function(entries){
		entries.forEach(function(entry){
			if(entry.isIntersecting){
				entry.target.classList.add('is--view');
				observer.unobserve(entry.target);
			}
		});
	},{
		threshold:0,
		rootMargin:'0px 0px -15% 0px'
	});

	aniItems.forEach(function(item){
		observer.observe(item);
	});
});


/* isotope */
$().ready(function() {
	ps();
});

var l_s = 0;

$(window).scroll(function(){
  var st = $(this).scrollTop(),
  		h = $(this).height(),
		dh = $(document).height();

	if (st < 120) {
		$('body').removeClass('s-on');
		$('body').removeClass('hid-n');
	} else {
		$('body').addClass('s-on');

		if (st < (l_s - 12)) {
			$('body').removeClass('hid-n');
		} else if (st > (l_s + 2)) {
			$('body').addClass('hid-n');
		}
		l_s = st;
	}

	if (st + h >= dh - 80) {
		$('body').addClass('is__se');
	} else {
		$('body').removeClass('is__se');
	}
});

$(function() {
    $('.product__media, .s__m .swiper-slide span').each(function() {
        var $media = $(this),
            $img = $media.find('img'),
            scale = 2.5,
            isDown = false,
            moved = false,
            isPinching = false,
            pinchStartDist = 0,
            pinchStartCenter = null,
            pinchScale = 1,
            targetPinchScale = 1,
            pinchX = 0,
            pinchY = 0,
            targetPinchX = 0,
            targetPinchY = 0,
            pinchRaf = null,
            startX = 0,
            startY = 0,
            x = 0,
            y = 0,
            lastX = 0,
            lastY = 0;

        function updateTransform(){
            $img.css({
                '--x':x + 'px',
                '--y':y + 'px'
            });
        }

        function getTouchCenter(touches){
            return {
                x:(touches[0].clientX + touches[1].clientX) / 2,
                y:(touches[0].clientY + touches[1].clientY) / 2
            };
        }

        function getSwiper(){
            return $media.closest('.swiper')[0]?.swiper;
        }

        function getTouchDist(touches){
            var dx = touches[0].clientX - touches[1].clientX,
                dy = touches[0].clientY - touches[1].clientY;

            return Math.sqrt(dx * dx + dy * dy);
        }

        function renderPinch(){
            if(!isPinching) return;

            pinchScale += (targetPinchScale - pinchScale) * 0.8;
            pinchX += (targetPinchX - pinchX) * 0.55;
            pinchY += (targetPinchY - pinchY) * 0.55;

            $img.css({
                '--pinch-scale':pinchScale,
                '--pinch-x':pinchX + 'px',
                '--pinch-y':pinchY + 'px'
            });

            pinchRaf = requestAnimationFrame(renderPinch);
        }

        function stopPinch() {
            var swiper = getSwiper();

            isPinching = false;
            pinchStartCenter = null;
            pinchScale = 1;
            targetPinchScale = 1;
            pinchX = 0;
            pinchY = 0;
            targetPinchX = 0;
            targetPinchY = 0;

			setTimeout(function(){
				moved = false;
			}, 50);
			
            if(pinchRaf){
                cancelAnimationFrame(pinchRaf);
                pinchRaf = null;
            }

            $media.removeClass('pinching');
            $('body').removeClass('fixed');

            $img.css({
                '--pinch-scale':1,
                '--pinch-x':'0px',
                '--pinch-y':'0px',
                'transform-origin':'center center'
            });

            if(swiper){
                swiper.allowTouchMove = true;
            }
        }

        $media.on('click', function(e){
            e.preventDefault();
            e.stopPropagation();

            if(moved){
                moved = false;
                return;
            }

            if(isPinching) return;

            var swiper = getSwiper();

            if($media.hasClass('zoomed')){
                $media.removeClass('zoomed dragging');
                $('body').removeClass('fixed');

                x = 0;
                y = 0;

                updateTransform();

                if(swiper){
                    swiper.allowTouchMove = true;
                }
            } else {
                $media.addClass('zoomed');

                if(!$img.attr('data-hires-loaded')){
                    var src = $img.attr('src');

                    if(src){
                        var hires = src.replace(/width=\d+/, 'width=3000');

                        $img.attr('data-original-src', src);
                        $img.attr('data-original-srcset', $img.attr('srcset') || '');

                        $img.removeAttr('srcset');
                        $img.attr('src', hires);
                        $img.attr('data-hires-loaded', 'true');
                    }
                }

                if(swiper){
                    swiper.allowTouchMove = false;
                }
            }
        });

        $media.on('touchstart', function(e){
            var touches = e.originalEvent.touches,
                swiper = getSwiper();

            if($media.hasClass('zoomed')) return;
            if(touches.length !== 2) return;

            e.preventDefault();

            isPinching = true;
            moved = true;

            pinchStartDist = getTouchDist(touches);
            pinchStartCenter = getTouchCenter(touches);

            pinchScale = 1;
            targetPinchScale = 1;
            pinchX = 0;
            pinchY = 0;
            targetPinchX = 0;
            targetPinchY = 0;

            var rect = $media[0].getBoundingClientRect(),
                originX = pinchStartCenter.x - rect.left,
                originY = pinchStartCenter.y - rect.top;

            $img.css({
                'transform-origin':originX + 'px ' + originY + 'px'
            });

            $media.addClass('pinching');
            $('body').addClass('fixed');

            if(swiper){
                swiper.allowTouchMove = false;
            }

            if(pinchRaf){
                cancelAnimationFrame(pinchRaf);
            }

            pinchRaf = requestAnimationFrame(renderPinch);
        });

        $media.on('touchmove', function(e){
            var touches = e.originalEvent.touches;

            if(!isPinching || touches.length !== 2) return;

            e.preventDefault();

            var currentDist = getTouchDist(touches),
                currentCenter = getTouchCenter(touches),
                nextScale = currentDist / pinchStartDist;

            targetPinchScale = Math.max(1, Math.min(scale, nextScale));
            targetPinchX = currentCenter.x - pinchStartCenter.x;
            targetPinchY = currentCenter.y - pinchStartCenter.y;
        });

        $media.on('touchend touchcancel', function(e){
            if(!isPinching) return;

            if(e.originalEvent.touches.length < 2){
                stopPinch();
            }
        });

        $media.on('pointerdown', function(e){
            if(!$media.hasClass('zoomed')) return;

            e.preventDefault();

            isDown = true;
            moved = false;

            startX = e.clientX;
            startY = e.clientY;

            lastX = x;
            lastY = y;

            $media.addClass('dragging');
        });

        $(document).on('pointermove', function(e) {
            if(!isDown) return;

            e.preventDefault();

            var dx = (e.clientX - startX) / scale,
                dy = (e.clientY - startY) / scale;

            if(Math.abs(dx) > 2 || Math.abs(dy) > 2){
                moved = true;
            }

            var newX = lastX + dx,
                newY = lastY + dy;

            var mediaW = $media.width(),
                mediaH = $media.height();

            var imgW = mediaW * scale,
                imgH = mediaH * scale;

            var maxX = (imgW - mediaW) / (scale * 2),
                maxY = (imgH - mediaH) / (scale * 2);

            x = Math.max(-maxX, Math.min(maxX, newX));
            y = Math.max(-maxY, Math.min(maxY, newY));

            updateTransform();
        });

        $(document).on('pointerup pointercancel', function() {
            if(!isDown) return;

            isDown = false;

            $media.removeClass('dragging');
        });
    });
});

$(function(){
	var loading = false;

	var observer = new IntersectionObserver(function(entries){
		entries.forEach(function(entry){
			if(entry.isIntersecting){
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			}
		});
	}, {
		root:null,
		rootMargin:'0px 0px 40% 0px',
		threshold:0
	});

	function observeItems($items){
		$items.each(function(i){
			$(this).css('--i', i);
			observer.observe(this);
		});
	}

	observeItems($('ul.p > li'));

	function loadMore(){
		var $next = $('.n-p');

		if(!$next.length || loading) return;

		var nextUrl = $next.attr('href');

		if($(window).scrollTop() + $(window).height() > $(document).height() - ($(window).height() * 2.5)){
			loading = true;

			$.get(nextUrl, function(data){
				var $html = $(data);
				var $items = $html.find('ul.p > li');
				var $newNext = $html.find('.n-p');

				$('ul.p').append($items);

				observeItems($items);

				if($newNext.length){
					$next.attr('href', $newNext.attr('href'));
				}else{
					$next.remove();
				}

				loading = false;
			});
		}
	}

	$(window).on('scroll', loadMore);
});

$(window).on('scroll resize', function() {
	var st = $(this).scrollTop(),
		h = $(document).height() - window.innerHeight,
		p = h ? st / h * 100 : 0;

	$('body').toggleClass('se__', st > window.innerHeight / 2);

	if ($('body').hasClass('se__')) {
		$('.ln__.l__2').css('top', p + '%');
	}
}).trigger('scroll');

$(window).on('mousemove touchstart touchmove', function(e) {
	var t = e.originalEvent.touches?.[0],
		x = t ? t.clientX : e.clientX,
		y = t ? t.clientY : e.clientY;

	$('.ln__.l__1').css('left', x + 'px');

	if (!$('body').hasClass('se__')) {
		$('.ln__.l__2').css('top', y + 'px');
	}
});

/*
$(window).scroll(function() {
    if ($(this).scrollTop() > (window.innerHeight / 2)) {
        $('body').addClass('se__');
    } else {
        $('body').removeClass('se__');
    }
});

$(window).on('mousemove touchstart touchmove', function(e) {
    var x,
        y;

    if (e.type === 'touchstart' || e.type === 'touchmove') {
        var touch = e.originalEvent.touches[0];

        if (!touch) return;

        x = touch.clientX;
        y = touch.clientY;
    } else {
        x = e.clientX;
        y = e.clientY;
    }

    $('.ln__.l__1').css('left', x + 'px');
    $('.ln__.l__2').css('top', y + 'px');
});
*/

/* size setting */
$(function(){
	if ($('.pd').length) {
		$(function(){
			$('fieldset').each(function(){
				var $fieldset = $(this);
				var legend = $fieldset.find('legend').text().trim().toLowerCase();
		
				if(legend === 'size'){
					var $one = $fieldset.find('input[type="radio"][value="1"]');
		
					if($one.length){
						$fieldset.find('label[for="' + $one.attr('id') + '"]').trigger('click');
					}
				}
			});
		});

		$(function(){
			$('variant-selects').each(function(){
				var hasColor = $(this).find('legend').filter(function(){
					var text = $(this).text().trim().toLowerCase();
		
					return text.includes('color') || text.includes('색상');
				}).length;
		
				if(hasColor){
					$('.p__info').addClass('has--2');
				}
			});
		});
	}


	function hideColorOption(){
		$('.product-option').each(function(){
			var text = $(this).find('dt').text().trim().toLowerCase().replace(':', '');
	
			if(text === 'color'){
				$(this).addClass('hidden');
			}
		});
	}
	
	$(function(){
		hideColorOption();
	
		new MutationObserver(function(){
			hideColorOption();
		}).observe(document.body, {
			childList:true,
			subtree:true
		});
	});
});

$(function() {
	/*iprs();*/
	
	function iprs() {
		var $bar = $('span#bar');
		
		imgLoad = imagesLoaded('body'),
			imgTotal = imgLoad.images.length,
			imgLoaded = 0,
			current = 0,
			
			prsTimer = setInterval(upp, 1000 / 60);
		
		imgLoad.on('progress', function() {
			imgLoaded++;
		});
		
		function upp() {
			var target = (imgLoaded / imgTotal) * 100;
			current += (target - current) * 0.1;
			
			$bar.css('width', current + '%');
			
			
			if (current >= 100) {
				clearInterval(prsTimer);
				$('#xy, #ovrlay').delay(500).fadeOut(800, 'swing').
				queue(function(next) {
					$('#pop').fadeIn(100, 'swing');
					$('#sy').delay(0).fadeTo(1000, 1, 'swing')
					next();
				});
			}
			
			if (current > 99.9) {
				current = 100;
			}
		}
	}
});


function sw_() {
    var sw = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty('--sw', sw + 'px');
}

sw_();
window.addEventListener('resize', sw_);